import React from "react";
import { FormattedMessage } from "react-intl";
import clsx from "clsx";

import styles from "@components/contractTypesPage/calendars/calendarContract.module.scss";

const CalendarFortnightlySecond = () => (
  <div className={styles.calendarContract}>
    <div className={clsx(styles.calendarContract__availability, styles.calendarContract__availabilityNone)}>
      <FormattedMessage id={'January'} />
    </div>
    <div className={clsx(styles.calendarContract__availability, styles.calendarContract__availabilityNone)}>
      <FormattedMessage id={'February'} />
    </div>
    <div className={clsx(styles.calendarContract__availability, styles.calendarContract__availabilityBooked)}>
      <FormattedMessage id={'March'} />
      <span className={styles.calendarContract__moveDate} style={{right: "70%"}}>
        <FormattedMessage id={'Move in'} />: <strong>10 <FormattedMessage id={'March'} /></strong>
      </span>
      <span className={styles.calendarContract__contractDate} style={{right: "100%"}}>
        <FormattedMessage id={'Contract start'} />: <strong>1 <FormattedMessage id={'March'} /></strong>
      </span>
    </div>
    <div className={clsx(styles.calendarContract__availability, styles.calendarContract__availabilityBooked)}>
      <FormattedMessage id={'April'} />
    </div>
    <div className={clsx(styles.calendarContract__availability, styles.calendarContract__availabilityBookedFirstHalf)}>
      <FormattedMessage id={'May'} />
      <span className={styles.calendarContract__moveDate} style={{right: "66%"}}>
        <FormattedMessage id={'Move out'} />: <strong>12 <FormattedMessage id={'May'} /></strong>
      </span>
      <span className={styles.calendarContract__contractDate} style={{right: "50%"}}>
        <FormattedMessage id={'Contract end'} />: <strong>15 <FormattedMessage id={'May'} /></strong>
      </span>
    </div>
    <div className={clsx(styles.calendarContract__availability, styles.calendarContract__availabilityNone)}>
      <FormattedMessage id={'June'} />
    </div>
  </div>
);

export default CalendarFortnightlySecond;
